import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { NgClass, PercentPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  Injector,
  ModelSignal,
} from '@angular/core';

import { decimalDivide } from '@shared/utils';

import { CostType } from '../enums/cost-type';

export interface AgInvestigatorForecastGroupRerenderComponentParams {
  patientInvoiceablesPercentage: ModelSignal<number>;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, PercentPipe],
  selector: 'aux-investigator-forecast-group-rerender',
  template: `
    <div class="flex h-full items-center">
      <span class="ag-cell-value w-full" role="presentation" [style.paddingLeft.px]="paddingLeft">
        <span class="ag-cell-wrapper w-full space-x-2">
          @if (isGroup && showGroup) {
            @if (params.node.expanded) {
              <span class="ag-group-expanded" (click)="onClick()">
                <span class="ag-icon ag-icon-tree-open" role="presentation"></span>
              </span>
            } @else {
              <span class="ag-group-contracted" (click)="onClick()">
                <span class="ag-icon ag-icon-tree-closed" role="presentation"></span>
              </span>
            }
          }
          <span class="ag-group-value" [ngClass]="{ 'ml-[11px]': !isGroup }">
            {{ params.value }}
          </span>

          @if (isPatientInvoiceables) {
            <p class="flex">
              (
              <span>
                {{ patientInvoiceablesPercentage() | percent: '1.0-2' }}
              </span>
              )
            </p>
          }
        </span>
      </span>
    </div>
  `,
})
export class AgInvestigatorForecastGroupRerenderComponent implements ICellRendererAngularComp {
  injector = inject(Injector);

  params!: AgInvestigatorForecastGroupRerenderComponentParams & ICellRendererParams;

  patientInvoiceablesPercentage = computed(() =>
    decimalDivide(this.params.patientInvoiceablesPercentage(), 100)
  );

  isGroup = false;
  isPatientInvoiceables = false;
  paddingLeft: number = 0;
  showGroup = false;

  private readonly PADDING_CHILD_NODE = 25;

  agInit(params: AgInvestigatorForecastGroupRerenderComponentParams & ICellRendererParams): void {
    this.params = params;
    this.paddingLeft = params.node.level * this.PADDING_CHILD_NODE;
    this.isGroup = !!params.node.group;

    this.showGroup =
      params.node.level === 0 &&
      params.value === CostType.PATIENT_VISITS &&
      !!params?.node?.aggData.patientGroup; // In case of empty state

    this.isPatientInvoiceables = params.value === CostType.PATIENT_INVOICEABLES;
  }

  onClick() {
    this.params.node.setExpanded(!this.params.node.expanded);
  }

  refresh(): boolean {
    return false;
  }
}
